const AppConfig = {
  api: {
    url: 'https://api.xosohd.com/'
  }
}

export default AppConfig;
